import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { parseFacilitySlug } from "./lib/helpers";
import { applyCachedFacilityManifest, initInstallCapture } from "./lib/pwa";

// Both must run before render: Chrome fires beforeinstallprompt early and only
// once, and it evaluates the manifest at load — so the facility-branded icon
// has to be in place by then, from cache if need be.
initInstallCapture();
applyCachedFacilityManifest(parseFacilitySlug());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
